if (!customElements.get('sj-motion-media')) {
  customElements.define('sj-motion-media', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.initialized = true;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused ??= this.reducedMotion.matches;
      this.updateButton = () => {
        const paused = this.video.paused;
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.textContent = paused ? '▶' : 'Ⅱ';
      };
      this.video.addEventListener('play', this.updateButton, options);
      this.video.addEventListener('pause', this.updateButton, options);
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause();
        else this.video.play().catch(this.updateButton);
      }, options);
      this.syncPlayback = () => {
        if (this.visible && !this.userPaused && !document.hidden) this.video.play().catch(this.updateButton);
        else this.video.pause();
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.syncPlayback();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.syncPlayback, options);
      this.reducedMotion.addEventListener('change', event => {
        this.userPaused = event.matches;
        this.syncPlayback();
      }, options);
      this.updateButton();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
      this.initialized = false;
    }
  });
}
